export function isPhoneAccount(phoneNumber) {
  if (!/^[0-9]{7,20}$/.test(phoneNumber)) {
    return false;
  }
  return true;
}
